import { EMPTY, Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { removeDefaultHandler } from './remove-default-handler.fn';

// Overwrite the existing errors message with a new message passed into this operator
// Does not pass the error to downstream oeprators/subscribers
export function customErrorMessage<T>(
  customMessage: string,
): (source: Observable<T>) => Observable<T> {
  return (source: Observable<T>): Observable<T> => {
    return source.pipe(
      catchError((err) => {
        removeDefaultHandler(err);
        err.notyService.error(customMessage);
        return EMPTY;
      }),
    );
  };
}
